import React from 'react'
import Home from "./pages/Home"
import About from "./pages/About"
import Sign from "./pages/Sign"
import SignPhm from "./pages/SignPhm"
import ComingSoon from "./pages/ComingSoon"
import SignIn from "./pages/login/SignIn"
import "./assets/scss/app.scss"
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import SignInPhm from './pages/login/SignInPhm'
import Stores from './pages/Userhome'
import DrugDetails from './pages/DrugDetails'
import Pharmacy from './pages/Store-Detail'
import Search from './pages/Search'
import UserDashboard from './pages/DashboardIndividual'
import ForgotPasswordStore from './pages/Forgot-Password-store'
import ForgotPasswordUser from './pages/Forgot-Password-user'
import ResetPasswordUser from './pages/Reset-PasswordUser'
import ResetPasswordStore from './pages/Reset-PasswordStore'
import ResetPasswordSuccess from './pages/Reset-PasswordSuccess'
import CartDetails from './pages/CartDetails'
import Billing from './pages/Billing'
import Verify from './pages/verify'
import { PrivateRoute } from './route/privateRoute'
import ScrollToTop from './components/scrollRestoration'


function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={About} />
          <Route path="/register" component={Sign} />
          <Route path="/registerphm" component={SignPhm} />
          <Route path="/coming-soon" component={ComingSoon} />
          <Route path="/login-individual" component={SignIn} />
          <Route path="/login-pharmacy" component={SignInPhm} />
          <PrivateRoute path="/user-home" component={Stores} />
          <PrivateRoute path="/buy" component={DrugDetails} />
          <PrivateRoute path="/store-detail" component={Pharmacy} />
          <PrivateRoute path="/search" component={Search} />
          <PrivateRoute path="/user-dashboard" component={UserDashboard} />
          <Route path="/verify" component={Verify} />
          <Route path="/store/forgot-password" component={ForgotPasswordStore} />
          <Route path="/user/forgot-password" component={ForgotPasswordUser} />
          <Route path="/user/reset-password/:id/:token" component={ResetPasswordUser} />
          <Route path="/store/reset-password/:id/:token" component={ResetPasswordStore} />
          <Route path="/reset-password-successful" component={ResetPasswordSuccess} />
          <PrivateRoute path="/cart-details" component={CartDetails} />
          <PrivateRoute path="/billing-info" component={Billing} />
          <Route path="*" render={() => <h1> Page not found </h1>}/>
        </Switch>



      </div>
    </Router>

  );
}

export default App;
